import Vue from 'vue';
import Vuex, { StoreOptions } from 'vuex';
import Meta from 'vue-meta';

import { mainModule } from './main';
import { State } from './state';
import { adminModule } from './admin';
import { sessionModule } from './session';

Vue.use(Vuex);
Vue.use(Meta);

const storeOptions: StoreOptions<State> = {
  modules: {
    main: mainModule,
    admin: adminModule,
    session: sessionModule
  }
};

export const store = new Vuex.Store<State>(storeOptions);

export default store;
